import Vue from 'vue'
import config from '@/common/config'
import { VuexResponse } from '@/helpers/vuex-action-builder'
import { createFeatureDecisions } from '@/services/features/featureDecisions'

const getDefaultState = () => {
  return {
    flags: config.get('app.featureFlags'), // @deprecated: this state value be removed in the future
    loadingCount: 0,
    crudLoadingCount: 0,
    featureFlags: {},
  }
}

const state = getDefaultState()

/**
 * --- WARNING! ---
 * @deprecated This module facilitates an outdated feature flag implementation and will be refactored to use the features controller.
 */

export default {
  namespaced: true,
  state,
  getters: {
    moduleName: () => 'features',
    featureFlags: (state) => createFeatureDecisions(state.flags), // @deprecated: this getter will be removed in the future
    isFeatureEnabled: (state) => (key) => state.featureFlags[key] ?? false,
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    /**
     * Resets store to default state; includes state.flags used by the deprecated featureFlags getter (createFeatureDecisions).
     */
    CLEAR_STORE(state) {
      Object.assign(state, getDefaultState())
    },
    /** @deprecated Updates state.flags consumed by the featureFlags getter (createFeatureDecisions). */
    SET_FEATURE_FLAGS(state, flags) {
      state.flags = flags
    },
    ADD_FEATURE_FLAG(state, { featureName, isEnabled }) {
      Vue.set(state.featureFlags, featureName, isEnabled)
    },
  },
  actions: {
    /** @deprecated Commits SET_FEATURE_FLAGS; feeds the deprecated featureFlags getter (createFeatureDecisions). */
    setFeatureFlags({ commit }, flags) {
      commit('SET_FEATURE_FLAGS', flags)
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
    async getFeatureFlag({ commit }, featureName) {
      return new VuexResponse(commit)
        .request(() => this.$api.features.getFeatureFlag(featureName))
        .withCommit('ADD_FEATURE_FLAG')
        .go()
    },
  },
}
